/* The one shape vocabulary (packages/ui/CLAUDE.md section C7, ADR-0092
 * amendment of 24 Sep 2026). Every part with a `shape` prop reads its corner
 * from this map, so one word never means two corners. Radii come from
 * theme.css: --radius is 10px, so rounded-md is 8px, rounded-lg 10px and
 * rounded-xl 14px. A part accepts only the words it lists in its own type.
 * Literal class strings so Tailwind sees them. */
export const SHAPE_CLASS = {
  /** 8px: the default corner of controls, badges and placeholders. */
  rounded: "rounded-md",
  /** Fully round ends; the width follows the content. */
  pill: "rounded-full",
  /** Fully round on a fixed square box (icon-only content, 1-2 characters). */
  circle: "rounded-full",
  /** 10px, the base radius: FloatingToolbar, CanvasMiniMap and Skeleton only
   *  (design-owner decision 9). */
  panel: "rounded-lg",
  /** 14px, the Card radius: Skeleton and CanvasMiniMap only (decision 8b). */
  card: "rounded-xl",
} as const;

export type Shape = keyof typeof SHAPE_CLASS;

export function shapeClass(shape: Shape): string {
  return SHAPE_CLASS[shape];
}
